import i18n from 'i18next';

import { readStoredLanguage } from './locale';
import { EN_TRANSLATIONS } from './translations';

void i18n.init({
  lng: readStoredLanguage(),
  fallbackLng: 'ru',
  supportedLngs: ['ru', 'en'],
  keySeparator: false,
  nsSeparator: false,
  interpolation: {
    escapeValue: false,
  },
  resources: {
    ru: { translation: {} },
    en: { translation: EN_TRANSLATIONS },
  },
});

export { i18n };
